import { useLocation, useNavigate } from 'react-router-dom'

import { performanceInsightsTabs } from '@/metrics/pages/PerformanceInsightsPage/constants'
import { getActiveTabValue } from '@/metrics/pages/PerformanceInsightsPage/helpers'

const usePerformanceInsightsTab = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const handleTabChange = value => {
    const selectedTab = performanceInsightsTabs.find(tab => tab.value === value)

    navigate({ pathname: selectedTab.path, search: location.search })
  }

  return {
    performanceInsightsTab: getActiveTabValue(location.pathname),
    handleTabChange,
  }
}

export default usePerformanceInsightsTab
